import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { accent } from '@/components/feature/solution/theme';

interface Step {
  icon: string;
  label: string;
  desc: string;
  time: string;
}

interface TraceStepsProps {
  title: string;
  subtitle: string;
  steps: Step[];
}

export default function TraceSteps({ title, subtitle, steps }: TraceStepsProps) {
  const a = accent('green');

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto">
        <SectionHeading title={title} subtitle={subtitle} />

        <ol className="mt-10 md:mt-12">
          {steps.map((step, idx) => (
            <li key={step.label}>
              <Reveal delay={Math.min(idx * 40, 200)}>
                <div className="flex gap-4 md:gap-6">
                  <div className="flex flex-col items-center">
                    <span className={`w-11 h-11 flex items-center justify-center rounded-full ${a.iconBox} shrink-0`}>
                      <i className={`${step.icon} text-lg`}></i>
                    </span>
                    {idx < steps.length - 1 && <span className={`w-px flex-1 my-1 ${a.line}`}></span>}
                  </div>

                  <div className="flex-1 pb-6 md:pb-7">
                    <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
                      <span className={`text-xs font-semibold ${a.text}`}>
                        {String(idx + 1).padStart(2, '0')}
                      </span>
                      <h3 className="font-heading font-bold text-foreground-950 text-base">{step.label}</h3>
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-500 whitespace-nowrap">
                        <i className="ri-time-line"></i>
                        {step.time}
                      </span>
                    </div>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}